import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFreeTrialCartItemIds } from '../lib/cart';
import { cartActions } from '../reducers/storeCart';
import * as types from '../types';
import useHardwareFirstCheckout from './useHardwareFirstCheckout';

/**
 * Removes free-trial bundles from the store cart when the visitor is enrolled in the
 * hardware-first checkout experiment (the arm and the free trial are mutually exclusive).
 * Covers carts persisted to localStorage before the visitor was assigned to the arm.
 */
export default function useHardwareFirstTrialCartCleanup(): void {
  const isHardwareFirstEnrolled = useHardwareFirstCheckout();
  // deliberately hardcoded to the store cart (not useCartMode): free-trial bundles only
  // exist in the acquisition cart, and this runs at the app root where the route-driven
  // cart mode would point at whichever cart the current page uses
  const cart = useSelector((state: types.AppState) => state.storeShop.cart);
  const products = useSelector((state: types.AppState) => state.config.products);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isHardwareFirstEnrolled) {
      return;
    }
    const freeTrialItemIds = getFreeTrialCartItemIds(cart, products);
    if (freeTrialItemIds.length > 0) {
      dispatch(cartActions.removeCartItems({ ids: freeTrialItemIds }));
    }
  }, [isHardwareFirstEnrolled, cart, products, dispatch]);
}
